import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent } from "vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import { sessionState } from "@/core/session";
import { notifyNetworkError } from "@/core/utils";
import { onMounted, ref, watch } from "vue";
import { apiPartners } from "./api";
export default /*#__PURE__*/ _defineComponent({
    __name: 'PartnerSelectField',
    props: {
        modelValue: {},
        allowSelectAll: { type: Boolean },
        partners: {}
    },
    emits: ['update:modelValue'],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const allPartners = ref(props.partners || null);
        // UI state
        const partnerId = ref(props.modelValue);
        // Event for two-way binding
        const emit = __emit;
        watch(partnerId, (val, prevVal) => {
            emit('update:modelValue', val);
        });
        const displayPartners = (partners) => {
            partners.sort((a, b) => a.name.localeCompare(b.name));
            let partnersByName = {};
            for (let partner of partners) {
                partnersByName[partner.name] = partner.id;
            }
            allPartners.value = partnersByName;
        };
        onMounted(() => {
            if (props.partners)
                return; // Partners already specified - no need to fetch again
            if (sessionState.cachedPartnerList) {
                displayPartners(sessionState.cachedPartnerList);
            }
            apiPartners.getForNetwork()
                .then((partnersInNetwork) => {
                sessionState.cachedPartnerList = partnersInNetwork;
                displayPartners(partnersInNetwork);
            })
                .catch(err => notifyNetworkError("Failed to load partners", err));
        });
        return (_ctx, _cache) => {
            const _component_FormSelectField = _resolveComponent("FormSelectField");
            return (!allPartners.value)
                ? (_openBlock(), _createBlock(LoadingSpinner, {
                    key: 0,
                    size: "small"
                }))
                : (_openBlock(), _createBlock(_component_FormSelectField, {
                    key: 1,
                    label: "Partner",
                    modelValue: partnerId.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((partnerId).value = $event)),
                    options: allPartners.value,
                    allowNullSelection: _ctx.allowSelectAll,
                    nullSelectionLabel: "-- All --"
                }, null, 8, ["modelValue", "options", "allowNullSelection"]));
        };
    }
});
